import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Answer } from '@app/definitions/interfaces';

@Component({
    selector: 'app-pupil-task-no-question',
    templateUrl: './pupil-task-no-question.component.html',
    styleUrls: ['./pupil-task-no-question.component.scss']
})
export class PupilTaskNoQuestionComponent implements OnInit {
    @Input() exercise;
    @Input() studentId: number;
    @Input() cardId: number;
    @Input() answer: string = '';

    @Output() exerciseCompleted = new EventEmitter();
    @Output() exerciseCorrect = new EventEmitter();
    @Output() answered = new EventEmitter();

    ngOnInit() {}

    keyboardClicked(button: number | string) {
        if (typeof button === 'number') {
            this.answer = this.answer + button.toString();
        } else {
            this.answer = this.answer + ', ' + button;
        }
    }

    clearAnswer() {
        this.answer = '';
    }

    checkAnswer() {
        let isCorrect: boolean = false;
        // Check if answer is correct
        for (const answ of this.exercise.answers) {
            if (this.answer === answ.shortAnswer || this.answer === answ.fullAnswer) {
                isCorrect = true;
                break;
            }
        }

        const exerciseAnswer: Answer = {
            student: this.studentId,
            card: this.cardId,
            shortAnswer: this.answer,
            exercise: this.exercise.id,
            correct: isCorrect
        };

        if (this.answer !== '') {
            this.clearAnswer();
        }

        this.answered.emit(exerciseAnswer);
        this.exerciseCompleted.emit(true);
        // send if exercise is correct
        if (isCorrect) {
            this.exerciseCorrect.emit(true);
        } else {
            this.exerciseCorrect.emit(false);
        }
    }
}
